import { Injectable, inject } from '@angular/core';
import { Observable, tap, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { Hold, WaitingTime } from './models/hold';
import { UserService } from 'src/app/services/user.service';
import { FromScreen } from 'src/app/models/from-screen';
import { catchError } from 'rxjs/operators';
import { AnalyticsService } from '../../../_core/analytics/analytics.service';

const HTTP_OPTIONS_URLENCODED = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class HoldsService {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiService);
  private readonly userService = inject(UserService);

  getHolds(): Observable<Hold[]> {
    const apiURL = `${this.apiService.API_URL}/patrons/${this.userService.getUserId()}/holds`;
    return this.http.get<Hold[]>(apiURL);
  }

  postHold(recordId: string, from: FromScreen, issueDate?: string, rhId?: string): Observable<Hold> {
    if (rhId) {
      return this.postHoldRssItem(recordId, from, rhId);
    }
    const apiURL = `${this.apiService.API_URL}/records/${recordId}/hold`;

    const body = `patronId=${this.userService.getUserId()}&from=${from}` + (issueDate ? `&issueDate=${issueDate}` : '');
    return this.http.post<Hold>(apiURL, body, HTTP_OPTIONS_URLENCODED).pipe(
      tap(() => {
        this.analyticsService.sendHoldEvent(true);
      }),
      catchError((error) => {
        this.analyticsService.sendHoldEvent(false);
        return throwError(() => error);
      })
    );
  }

  private postHoldRssItem(recordId: string, from: FromScreen, rhId: string) {
    const apiURL = `${this.apiService.API_URL}/records/${recordId}/hold/items/${rhId}`;
    const body = `patronId=${this.userService.getUserId()}&from=${from}`;
    return this.http.post<Hold>(apiURL, body, HTTP_OPTIONS_URLENCODED);
  }

  deleteHold(holdId: string): Observable<Hold> {
    return this.http.post<Hold>(`${this.apiService.API_URL}/holds/${holdId}/cancel`, {});
  }

  getWaitingTime(holdId: string): Observable<WaitingTime> {
    return this.http.get<WaitingTime>(`${this.apiService.API_URL}/holds/${holdId}/waiting-time`);
  }
}
